import { render, staticRenderFns } from "./ItemExternalSource.vue?vue&type=template&id=02f66beb"
import script from "./ItemExternalSource.vue?vue&type=script&lang=js"
export * from "./ItemExternalSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports